module.exports = __webpack_public_path__ + "static/error-fdc9dbdcc19fc55b79ac8f9c4f27540b.png";